import { useState } from "react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { PageHeader } from "@/components/layout/page-header";
import { PageTabs } from "@/components/layout/page-tabs";
import { ConversaAgente } from "@/components/agente/conversa";
import { BoletimAgente } from "@/components/agente/boletim";
import { ContatosAgente } from "@/components/agente/contatos";
import { EnvioAutomatico } from "@/components/agente/envio-automatico";

// Tela própria do Rizoma Agent (Rizoma_Agente_Etapa1_Boletim_Spec.md §6).
//
// Rota de PLATAFORMA, como /admin: não entra no registry de módulos
// (client/src/lib/modules.ts) nem no gating por plano. O agente deixou de ser
// uma tela do Manejo quando o boletim passou a atravessar Cacho, Equipe e
// Manejo — continuar pendurado num módulo seria mentir sobre o que ele é.
//
// Quatro abas: Conversa (o chat da Fase A0, movido de /manejo intacto), Boletim
// (prévia do diário e do semanal + histórico de envios), Contatos (quem pode
// receber, inclusive grupos de WhatsApp) e Envio automático (as assinaturas —
// cada canal com seu próprio horário). WhatsApp entrega de verdade desde o
// Ciclo 3a, pelo GZappy; o WhatsApp oficial (Meta Cloud API) segue indisponível.
//
// As quatro abas são `PageTabs`, não segmented: elas trocam PÁGINA dentro da
// página, não a visão dos mesmos dados. No celular a faixa rola na horizontal —
// quatro abas não cabem numa linha, e o uso real é no campo, no telefone.

const ABAS = [
  { id: "conversa", label: "Conversa" },
  { id: "boletim", label: "Boletim" },
  { id: "contatos", label: "Contatos" },
  { id: "envio", label: "Envio automático" },
];

export default function AgentePage() {
  const [aba, setAba] = useState("conversa");

  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto space-y-4">
      <PageHeader
        titulo="Agente"
        descricao="Converse com o Rizoma Agent, confira e configure os boletins diário e semanal."
      />

      <PageTabs abas={ABAS} ativa={aba} onChange={setAba} />

      <Tabs value={aba} onValueChange={setAba}>

        <TabsContent value="conversa" className="mt-4">
          <ConversaAgente />
        </TabsContent>

        <TabsContent value="boletim" className="mt-4">
          <BoletimAgente />
        </TabsContent>

        <TabsContent value="contatos" className="mt-4">
          <ContatosAgente />
        </TabsContent>

        <TabsContent value="envio" className="mt-4">
          <EnvioAutomatico />
        </TabsContent>
      </Tabs>
    </div>
  );
}
